import { Ng2StateDeclaration } from "@uirouter/angular";
import { ChangePassword } from "./change-password.component";
import { ForgotPassword } from "./forgot-password.component";
import { ResetPassword } from "./reset-password.component";

export const passwordState: Ng2StateDeclaration = {
    name: "app.password",
    url: "/password",
    abstract: true
};

export const changePasswordState: Ng2StateDeclaration = {
    name: "app.password.change",
    url: "/change",
    views: {
        "main-view@app": {
            component: ChangePassword
        }
    }
};

export const forgotPasswordState: Ng2StateDeclaration = {
    name: "app.password.forgot",
    url: "/forgot",
    views: {
        "main-view@app": {
            component: ForgotPassword
        }
    },
    data: {
        allowAnonymous: true
    }
};

export const resetPasswordState: Ng2StateDeclaration = {
    name: "app.password.reset",
    url: "/reset?{userId:string}&{company:string}&{token:string}",
    views: {
        "main-view@app": {
            component: ResetPassword
        }
    },
    resolve: {
        userId: ["$stateParams", function ($stateParams) {
            return $stateParams.userId;
        }],
        company: ["$stateParams", function ($stateParams) {
            return $stateParams.company;
        }],
        token: ["$stateParams", function ($stateParams) {
            return $stateParams.token;
        }]
    },
    data: {
        allowAnonymous: true
    }
};



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/password/password.states.ts